import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { RHYTHMS } from "../../data/tilio";
import { Reveal, SectionHeading, RhythmIcon } from "./Shared";

export default function Activities() {
    return (
        <section id="co-robic" data-testid="activities-section" className="py-24 lg:py-32">
            <div className="mx-auto max-w-6xl px-6 lg:px-10">
                <SectionHeading
                    number="03"
                    eyebrow="Co robić"
                    title="Jak chcesz spędzić ten czas?"
                    sub="Wybierz swój rytm — blisko natury, dla siebie lub z przestrzenią na skupienie."
                    center
                    testId="activities-heading"
                />
                <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
                    {RHYTHMS.map((r, i) => (
                        <Reveal key={r.slug} delay={i * 0.1} className="h-full">
                            <article
                                data-testid={`rhythm-card-${r.slug}`}
                                className="flex h-full flex-col items-center p-8 text-center"
                            >
                                <span className="flex h-16 w-16 items-center justify-center text-pine">
                                    <RhythmIcon slug={r.slug} className="h-9 w-9" />
                                </span>
                                <h3 className="mt-6 font-serif text-3xl tracking-tight text-pine">{r.title}</h3>
                                <p className="mt-3 text-[13px] uppercase tracking-[0.2em] text-muted-foreground">{r.tags}</p>
                                <p className="mt-4 flex-1 text-base leading-relaxed text-sage">{r.desc}</p>
                                <Link
                                    data-testid={`rhythm-more-btn-${r.slug}`}
                                    to={`/rytm/${r.slug}`}
                                    className="btn-primary btn-subpage mt-8"
                                >
                                    Poznaj
                                    <ArrowRight className="h-4 w-4" strokeWidth={1.25} />
                                </Link>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
